import * as React from 'react';
import { navigate } from 'router';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import OrgLocationHeader from '~/apps/shared/containers/locations/OrgLocationHeader';


export default function() {
  return (
    <CurrentOrgInjector
      component={OrgLocationHeader}
      onCreate={() => {
        return navigate('sender.locations.create');
      }}
    />
  );
};
